// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Header, Segment, Label } from 'semantic-ui-react'

export default class MakerComp extends Component {
  render () {
    return (
      <div style={{ paddingLeft: 14, paddingRight: 14, marginBottom: '10px' }}>
        <Segment onClick={() => this.props.newComp('header')} className='cursor' fluid>
          <Header as='h4'>
            Header
            <Header.Subheader>Large structured header</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('text')} className='cursor' fluid>
          <Header as='h4'>
            Text
            <Header.Subheader>Rich formatted text</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('button')} className='cursor' fluid>
          <Header as='h4'>
            Button
            <Header.Subheader>Accept url or navigation</Header.Subheader>
          </Header>
        </Segment>

        <h3 className='center'>Multimedia</h3>

        <Segment fluid className='cursor' onClick={() => this.props.newComp('image')}>
          <Header as='h4'>
            Image
            <Header.Subheader>JPEG, PNG or GIF</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('video')} className='cursor' fluid>
          <Header as='h4'>
            Video
            <Header.Subheader>YouTube or video url</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('audio')} className='cursor' fluid>
          <Header as='h4'>
            Audio
            <Header.Subheader>Mini Audio player</Header.Subheader>
          </Header>
        </Segment>

        <h3 className='center'>Contact information</h3>

        <Segment className='cursor' onClick={() => this.props.newComp('phone')} fluid>
          <Header as='h4'>
            Phone
            <Header.Subheader>Open default phone app</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('email')} className='cursor' fluid>
          <Header as='h4'>
            Email
            <Header.Subheader>Open default email app</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('address')} className='cursor' fluid>
          <Header as='h4'>
            Address
            <Header.Subheader>Open default maps app</Header.Subheader>
          </Header>
        </Segment>

        <h3 className='center'>Extensions</h3>

        <Segment onClick={() => this.props.newComp('chart')} className='cursor' fluid>
          <Label attached='top right' color='black' size='small'>
            New
          </Label>
          <Header as='h4'>
            Chart
            <Header.Subheader>Display chart graphs</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('rss')} className='cursor' fluid>
          <Label attached='top right' color='black' size='small'>
            New
          </Label>
          <Header as='h4'>
            RSS
            <Header.Subheader>News article feed</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('list')} className='cursor' fluid>
          <Header as='h4'>
            List
            <Header.Subheader>Display a list from CSV</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('webview')} className='cursor' fluid>
          <Header as='h4'>
            Webview
            <Header.Subheader>Embed webview container</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('map')} className='cursor' fluid>
          <Header as='h4'>
            Map
            <Header.Subheader>Embed Google Maps</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('admob')} className='cursor' fluid>
          <Header as='h4'>
            AdMob
            <Header.Subheader>Display banner ad</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('wordpress')} className='cursor' fluid>
          <Header as='h4'>
            WordPress
            <Header.Subheader>Display blog posts</Header.Subheader>
          </Header>
        </Segment>

        <Segment onClick={() => this.props.newComp('woocommerce')} className='cursor' fluid>
          <Header as='h4'>
            WooCommerce
            <Header.Subheader>Display store products</Header.Subheader>
          </Header>
        </Segment>
      </div>
    )
  }
}
